var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"placement":"top","content":_vm.content,"disabled":!_vm.isOverflowed}},[_c('span',{ref:"text",staticClass:"ellipsis-text"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }